// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// This file is automatically generated. Do not edit it directly.
const SUPABASE_URL = "https://bkshgrszrflgxllhsyne.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJrc2hncnN6cmZsZ3hsbGhzeW5lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA1MzQ4NzcsImV4cCI6MjA1NjExMDg3N30.kXDDxoNh3XWSWT-OimwTAqjXRFNYb1m21dMEax1SYIU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);

// Helper functions
export async function getCurrentUser() {
  const { data, error } = await supabase.auth.getUser();

  if (error) {
    console.error("Error getting current user:", error);
    return null;
  }

  return data.user;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();

  if (error) {
    console.error("Error signing out:", error);
    throw error;
  }

  return true;
}
